<template>
	<div class="select-user-div">
		<pt-modal :title="title" :visible="modal.visible" :loading="modal.loading" @ok="handleOk"
		          @cancel="handleCancel">
			<div slot="content">
				<div><span>{{$t('user.selectUser.checkUser')}}</span></div>
				<div class="checkUser-div">
					<div class="userItem" v-for="(item,index) in checkUser" v-if="item.userName">
						<div>
							<a-avatar icon="user" :src="getUserImage(item.headimg)"/>
						</div>
						<div class="userItemRow">
							<div class="userItemName">{{item.userName}}</div>
							<pt-icon @click.native="removeItem(item)" type="icon-quxiao"/>
						</div>
					</div>
				</div>
				<div class="select-div">
					<div class="left">
						<div class="title">{{$t('user.selectUser.tips')}}</div>
						<div class="company-select" v-if='approvesCompanyId'>
							<span  class='active'>{{approvesCompanyName}}</span>
						</div>
						<div class="company-select" v-else>
							<div><span @click="selectCompany()" :class="[queryVO.companyId == ''?'active':'']">{{$t('user.selectUser.all')}}</span>
							</div>
							<a-checkbox-group style='flex-direction: column' v-model="checkComany" v-if="showCheckbox"  @change='changeBox'>
								<div style='margin-top: 10px;margin-left: -44px' v-for="(item,index) in companyInfos">
									
									<a-checkbox  :value="item.id"  @change='onChangeBox' style="margin-right: 5px;"></a-checkbox>
									<span @click="selectCompany(item.id)"
									      :class="item.id == queryVO.companyId ?'active':''">{{item.name}}</span>
								</div>
							</a-checkbox-group>
							<div v-for="(item,index) in companyInfos" v-else>
                <span @click="selectCompany(item.id)"
                      :class="item.id == queryVO.companyId ?'active':''">{{item.name}}</span>
							</div>
						</div>
					</div>
					<div class="right">
						<div>
							<pt-search v-model="queryVO.name" @searchEvent="initData" style="width: 100%;"
							           :placeholder="$t('user.selectUser.inputTips')"/>
						</div>
						<div >
							<a-spin :spinning="tableInfo.loading">
								<div v-bar style="height:calc(100vh - 445px);height: 300px;">
									<div class='itemStyle'>
										<a-checkbox-group v-model="checkUserIds" v-if="checkbox" class="item-body" @change="onChange">
											<div class="user-item" v-for="(item,index) in tableInfo.tableData" :style="item.companyId ==  queryVO.companyId || !queryVO.companyId ? '':'display: none'">
												<div class="checkbox-item">
													<a-checkbox :value="item.id" @change="itemChange" :key="item.id"></a-checkbox>
												</div>
												<div @click="changeItem(item)" class="user-item-box">
													<div class="user-item-left">
														<div>
															<a-avatar icon="user" :src="getUserImage(item.headimg)"/>
															<span style="padding-left: 10px;">{{item.userName}}</span>
														</div>
													</div>
													<div class="user-item-right" >
														{{item.postName}}
													</div>
												</div>
											</div>
										</a-checkbox-group>
										<a-radio-group v-else class="item-body" @change="onRadioChange" v-model="radioValue">
											<div class="user-item" v-for="(item,index) in tableInfo.tableData" :style="item.companyId ==  queryVO.companyId || !queryVO.companyId ? '':'display: none'">
												<div class="checkbox-item">
													<a-radio :value="item.id"></a-radio>
												</div>
												<div @click="onRadioChangeClick(item.id)" class="user-item-box">
													<div class="user-item-left">
														<div>
															<a-avatar icon="user" :src="getUserImage(item.headimg)"/>
															<span style="padding-left: 10px;">{{item.userName}}</span>
														</div>
													</div>
													<div class="user-item-right">
														{{item.postName}}
													</div>
												</div>
											</div>
										</a-radio-group>
										<pt-empty v-if="tableInfo.tableData.length == 0 && !tableInfo.tableData.loading"></pt-empty>
									</div>
								</div>
							</a-spin>
						</div>
					</div>
				</div>
			</div>
		</pt-modal>
	</div>
</template>

<script>
import UserApi from '@/api/sys/user'
import DepApi from '@/api/sys/organization'
import holidayAdjustApi from '@/api/mine/holidayAdjust'

export default {
	name: 'ptSelectUser',
	props: {
		notAllowToRemove:{
			type:Array,
			default: ()=>{return []}
		},
		isShare:{//判断是不是联系人共享选择
			required: false,
			type: Boolean
		},
		isLeaveUpdate:{
			required: false,
			type: Boolean
		},
		leaveType:{
			required: false,
			type: String,
			default:undefined,
		},
		visible: {
			required: true,
			type: Boolean
		},
		checkbox: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			required: true
		},
		value: {
			type: [String, Array],
			default:()=>{return []}
		},
		showCheckbox:{
			type: Boolean,
			default: false
		},
		approvesCompanyId:{
			type:String,
			default:undefined
		},
		checkComanys:{
			type: [String, Array],
			default:()=>{return []}
		}
	},
	data() {
		return {
			defaultValue:null,
			tableInfo: {
				tableData: [],
				loading: false
			},
			modal: {
				visible: this.visible,
				loading: false
			},
			queryVO: {
				companyId: '',
				name: ''
			},
			users: [],
			approvesCompanyName:null,
			companyInfos: [],
			checkUser: [],
			checkComany: [],
			checkUserIds: [],
			radioValue: null
		}
	},
	watch: {
		visible(newValue) {
			this.modal.visible = newValue
			if(newValue){
				this.queryVO.companyId = ''
				this.queryVO.name = ''
				this.init()
				this.initData()
			}
		},
		value(newValue) {
			this.initSelectValue()
		},
		checkComanys(newValue){
			this.initCompany()
		}
	},
	computed: {
		usersMap() {
			let arr = []
			this.tableInfo.tableData.forEach(item => {
				arr[item.id] = item
			})
			return arr
		},
		checkUserMap() {
			let arr = []
			this.checkUser.forEach(item => {
				arr[item.id] = item
			})
			return arr
		}
	},
	mounted() {
		// this.init()
		// this.initData()
		
	},
	methods: {
		changeBox(e){
			console.log("changeBox",e)
			console.log("changeBox222",this.checkComany)
			// e.forEach(data => {
			//   if (this.checkComany.indexOf(data) == 0){
			//     this.checkComany.push(data)
			//   }
			// })
			console.log("changeBox4444",this.checkComany)
		},
		onChangeBox(e){
			console.log("onChangeBox",e)
			if (e.target.checked) {
				this.checkUserByComanyId(e.target.value)
				if (this.checkComany.indexOf(e.target.value) == 0){
					this.checkComany.push(e.target.value)
				}
			}else {
				this.unCheckUserByComanyId(e.target.value)
				this.checkComany =   this.checkComany.filter((item)=>{
					return item !== e.target.value
				})
				console.log("changeBox333",this.checkComany)
			}
		},
		checkUserByComanyId(companyId){
			UserApi.selectUsers({companyId:companyId}).then(res => {
				if (res.code == 1) {
					let arr =  res.data;
					let changeIds = [];
					console.log("-----arr",arr)
					console.log("-----checkUserIds",this.checkUserIds)
					console.log("-----checkUser",this.checkUser)
					console.log("-----defaultValue",this.defaultValue)
					// this.checkUser.push(arr)
					arr.forEach(item => {
						console.log("this.checkUserIds.indexOf(item.id)",this.checkUserIds.indexOf(item.id))
						if (this.checkUserIds.indexOf(item.id) == -1){
							this.checkUserIds.push(item.id)
							this.checkUser.push(item)
							this.defaultValue.push(item)
						}
						// changeIds.push(item.id)
					})
					// this.onChange(changeIds)
				}
			})
		},
		unCheckUserByComanyId(companyId){
			UserApi.selectUsers({companyId:companyId}).then(res => {
				if (res.code == 1) {
					let arr =  res.data;
					let changeIds = [];
					console.log("arr",arr)
					console.log("checkUserIds",this.checkUserIds)
					arr.forEach(item => {
						let item1 = this.checkUserMap[item.id]
						console.log("item",item1)
						if(this.notAllowToRemove.length > 0 && this.notAllowToRemove.indexOf(item1.accountid) >= 0){
							this.$message.error(this.$t('deal.addDeal.errorInfo.cannotRemoveColumnAUser'))
							return
						}
						this.defaultValue.splice(this.checkUser.indexOf(item1), 1)
						this.checkUser.splice(this.checkUser.indexOf(item1), 1)
						this.checkUserIds.splice(this.checkUserIds.indexOf(item1.id), 1)
						// this.changeItem(item1)
					})
					console.log("-----",changeIds)
					// changeIds.forEach(data => {
					//   if (this.checkUserMap[data]) {
					//     this.checkUser.splice(this.usersMap[data],1)
					//     this.defaultValue.splice(this.usersMap[data],1)
					//   }
					// })
					
				}
			})
		},
		init(){
			if(this.value){
				this.defaultValue = JSON.parse(JSON.stringify(this.value))
			}
			this.initCompanyInfo()
		},
		initCompanyInfo() {
			DepApi.selectCompanyInfo().then(res => {
				if (res.code == 1) {
					this.companyInfos = res.data.filter(o=>o.id != '6da7fb7980090688' && o.id != '6450d5589df1f8b7');
					if(this.approvesCompanyId){
						this.companyInfos.forEach(data=>{
							if(this.approvesCompanyId == data.id){
								this.approvesCompanyName = data.name
							}
						})
					}
				}
			})
		},
		initCompany(){
			this.checkComany = this.checkComanys
			console.log("initCompany",this.checkComany,this.checkComanys)
			
		},
		initSelectValue() {
			if (this.defaultValue) {
				if (this.checkbox) {
					//多选处理
					this.checkUserIds = []
					this.checkUser = []
					this.defaultValue.forEach(data => {
						this.checkUserIds.push(data.id)
						this.checkUser.push(data)
					})
				} else {
					//
					this.radioValue = this.defaultValue.id
					this.checkUser = []
					this.checkUser.push(this.defaultValue)
				}
			}
			
		},
		queryData(){
			this.tableInfo.loading = true;
			UserApi.selectUsers(this.queryVO).then(res => {
				if (res.code == 1) {
					this.tableInfo.tableData = res.data;
				}
			}).finally(() => {
				this.tableInfo.loading = false
			})
		},
		initData() {
			this.tableInfo.loading = true
			if(this.approvesCompanyId){
				this.queryVO.companyId = this.approvesCompanyId
			}
			UserApi.selectUsers(this.queryVO).then(res => {
				if (res.code == 1) {
					this.tableInfo.tableData = res.data
					this.initSelectValue()
				}
			}).finally(() => {
				this.tableInfo.loading = false
			})
		},
		handleCancel() {
			this.modal.visible = false
			this.checkUser = []
			this.checkUserIds = []
			this.radioValue = null
			this.queryVO.companyId = ''
			this.$emit('close')
		},
		
		selectCompany(companyId) {
			if (companyId) {
				this.queryVO.companyId = companyId
			} else {
				this.queryVO.companyId = ''
			}
		},
		handleOk() {
			if(this.isShare && this.checkUser.length == 0){ //如果是联系人分享至少选择一个要分享的人员
				this.$message.error(this.$t('user.selectUser.selectTip'));
				return;
			}
			if (this.checkbox) {
				this.$emit('input', this.checkUser)
				this.$emit('ok', this.checkUser,this.checkComany)
			} else {
				this.$emit('input', this.checkUser[0])
				this.$emit('ok', this.checkUser[0])
			}
			this.handleCancel()
		},
		//每项选择改变 如果是取消选择,将删除已选择的
		itemChange(event) {
			let value = event.target.value
			if (!event.target.checked) {
				let item = this.checkUserMap[value]
				console.log("item",item)
				if(this.notAllowToRemove.length > 0 && this.notAllowToRemove.indexOf(item.accountid) >= 0){
					this.$message.error(this.$t('deal.addDeal.errorInfo.cannotRemoveColumnAUser'))
					return
				}
				this.defaultValue.splice(this.checkUser.indexOf(item), 1)
				this.checkUser.splice(this.checkUser.indexOf(item), 1)
				this.checkComany.splice(this.checkComany.indexOf(item.companyId), 1)
			}else{
				console.log("itemChange")
				if (this.isLeaveUpdate){
					holidayAdjustApi.getByIds({idList:this.usersMap[value].accountid,type:this.leaveType}).then(res => {
						if (res.code = 1) {
							if (res.data.length == 0){
								this.$message.error("此人没假期信息")
								console.log(this.checkUserIds,event.target.value,this.checkUserIds.indexOf(event.target.value))
								this.checkUserIds.splice(this.checkUserIds.indexOf(event.target.value),1)
								return
							}
							console.log("------")
							let changeValues = this.checkUserIds.slice()
							changeValues.push(event.target.value)
							this.onChange(changeValues,true)
						}
					})
				}else {
					console.log("------=====")
					let changeValues = this.checkUserIds.slice()
					changeValues.push(event.target.value)
					this.onChange(changeValues)
				}
			}
		},
		changeItem(item){
			console.log("changeItem",item)
			if(this.checkUserIds.indexOf(item.id) >= 0){
				let deleteUser = this.checkUser.find(e=>{return e.id == item.id})
				this.removeItem(deleteUser)
			}else{
				if (this.isLeaveUpdate){
					var resData = []
					holidayAdjustApi.getByIds({idList:item.accountid,type:this.leaveType}).then(res => {
						if (res.code = 1) {
							if (res.data.length == 0){
								this.$message.error("此人没假期信息")
								return
							}
							let changeValues = this.checkUserIds.slice()
							changeValues.push(item.id)
							this.onChange(changeValues,true)
						}
					})
				}else {
					let changeValues = this.checkUserIds.slice()
					changeValues.push(item.id)
					this.onChange(changeValues)
				}
			}
		},
		removeItem(item) {
			if(this.notAllowToRemove.length > 0 && this.notAllowToRemove.indexOf(item.accountid) >= 0){
				this.$message.error(this.$t('deal.addDeal.errorInfo.cannotRemoveColumnAUser'))
				return
			}
			this.defaultValue.splice(this.checkUser.indexOf(item), 1)
			this.checkUser.splice(this.checkUser.indexOf(item), 1)
			this.checkUserIds.splice(this.checkUserIds.indexOf(item.id), 1)
			this.radioValue = null
		},
		onChange(changeValues,suecess) {
			if (this.isLeaveUpdate){
				if (suecess){
					console.log("onChange1")
					changeValues.forEach(data => {
						if (!this.checkUserMap[data]) {
							this.checkUser.push(this.usersMap[data])
							this.defaultValue.push(this.usersMap[data])
						}
					})
					this.$emit('input',this.checkUser)
				}
			}else {
				console.log("onChange2")
				changeValues.forEach(data => {
					if (!this.checkUserMap[data]) {
						this.checkUser.push(this.usersMap[data])
						this.defaultValue.push(this.usersMap[data])
					}
				})
				this.$emit('input',this.checkUser)
			}
		},
		onRadioChange(event) {
			console.log(event)
			this.checkUser = []
			this.checkUser.push(this.usersMap[event.target.value])
			this.defaultValue.push(this.usersMap[event.target.value])
		},
		onRadioChangeClick(id) {
			console.log(event)
			this.checkUser = []
			this.radioValue = id;
			this.checkUser.push(this.usersMap[id])
			this.defaultValue.push(this.usersMap[id])
		},
		getUserImage(fileId) {
			if (fileId && this.visible) {
				return this.$util.getFileUrl(fileId)
			} else {
				return undefined
			}
		}
	}
}
</script>

<style scoped lang="less">
@import "../../core/diy";

.checkUser-div {
	display: flex;
	flex-direction: row;
	align-items: center;
	border-bottom: 1px solid @border-color;
	margin-bottom: 10px;
	min-height: 84px;
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
	
	> div {
		margin: 5px 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		min-width: 100px;
	}
	.userItem{
		.userItemRow{
			display: flex;
			flex-direction: row;
			align-items: center;
			.userItemName{
				font-size: 14px;
				color: #4D4D4D;
				margin-right: 4px;
			}
		}
	}
}


.select-div {
	display: flex;
	
	> .left {
		width: 160px;
		background-color: @block-color;
		display: flex;
		color: @text-color-9;
		flex-direction: column;
		
		.title {
			height: 40px;
			display: flex;
			padding-left: 10px;
			margin: 0px 10px;
			align-items: center;
			border-bottom: 1px solid @border-color;
		}
		
		.active {
			color: @primary-color;
		}
		
		.company-select {
			padding-left: 30px;
			margin-top: 10px;
			
			> div {
				cursor: pointer;
				color: @text-color-3;
				display: flex;
				align-items: center;
				height: 40px;
			}
		}
	}
	
	> .right {
		
		/deep/ .vb-dragger-styler{
			height:calc(100% - 0px) !important;
			margin: 0px 0px 0px 5px !important;
		}
		
		
		width: 480px;
		margin-left: 10px;
		padding: 10px 5px 10px 10px;
		background-color: @block-color;
		
		.item-body {
			width: 98%;
		}
		
		.user-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 50px;
			border-bottom: 1px solid @border-color;
			
			.checkbox-item {
				margin-right: 30px;
			}
			.user-item-box{
				display:flex;
				flex:1;
				padding-right: 10px;
				.user-item-left {
					display: flex;
					align-items: center;
					flex: 1;
				}
			}
		}
		
		.table-div {
			padding: 0px 15px;
			
			/deep/ .el-table {
				background-color: transparent;
			}
			
			/deep/ td {
				background-color: transparent;
			}
			
			/deep/ tr {
				background-color: transparent;
			}
			
			/deep/ .el-table__row:hover td {
				background-color: transparent !important;
			}
		}
	}
}
</style>